import { buildContext } from '@toss/react';

import { type SearchQuizsetRes } from '@/api';
import { type QuizListType } from '@/shared/quizList/QuizListType';

import { type QuizCardMenuItem } from './useGetQuizListItemButtons';

export type QuizListItemProps = {
  alwaysDropDownMenu: boolean;
  quizSet: SearchQuizsetRes;
  menuItems: QuizCardMenuItem[];
  isHideAuthor: boolean;
  subjectName: string | undefined;
  eventLocation: QuizListType;
  eventAdditionalProperty?: Partial<Record<QuizListType, Record<string, any>>>;
};

export const [QuizListItemProvider, useQuizListItemProvider] =
  buildContext<QuizListItemProps>('BuildContext', null);
